export default "__VITE_ASSET__CP6N6MQy__"